import React from 'react';
import { SvgIcon } from '@material-ui/core';

const FileIcon = props => {
  return(
    <SvgIcon viewBox="0 0 250 250" {...props}>
      <g id="file-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path d="M46.875,0 C38.28125,0 31.25,7.03125 31.25,15.625 L31.25,234.375 C31.25,242.96875 38.28125,250 46.875,250 L203.125,250 C211.71875,250 218.75,242.96875 218.75,234.375 L218.75,62.5 L156.25,0 L46.875,0 Z" id="Path" fill="#E2E5E7" fillRule="nonzero"></path>
        <path d="M171.875,62.5 L218.75,62.5 L156.25,0 L156.25,46.875 C156.25,55.46875 163.28125,62.5 171.875,62.5 Z" id="Path" fill="#B0B7BD" fillRule="nonzero"></path>
        <polygon id="Path" fill="#CAD1D8" fillRule="nonzero" points="218.75 109.375 171.875 62.5 218.75 62.5"></polygon>
      </g>
    </SvgIcon>
  );
};

export default FileIcon;
